import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UnlockingAccountComponent } from './unlocking-account.component';
import { TrWrapperTwoColumnsModule } from '../tr-wrapper-two-columns/tr-wrapper-left-column.module';
import { RouterModule } from '@angular/router';
import { TrSpinnerButtonDirectiveModule } from '../../directives';

@NgModule({
    imports: [
        CommonModule,
        TrWrapperTwoColumnsModule,
        RouterModule,
        TrSpinnerButtonDirectiveModule,
    ],
    declarations: [ UnlockingAccountComponent ],
    exports: [ UnlockingAccountComponent ],
})
export class UnlockingAccountModule {}
